// extracted by mini-css-extract-plugin
export default {"legend":"SeverityLegend_legend__7dPln","item":"SeverityLegend_item__EOoCu","label":"SeverityLegend_label__Jhrya"};